<template>
  <div class="filials-map screen">
    <div class="container">
      <div class="position-relative mb-3 mb-md-5">
        <div class="border-title">{{ Lang.get('js.filials') }}</div>
        <div class="sorts-block">
          <div class="sort-item">
            <el-select v-model="city" clearable
                       @change="changeCity"
                       :placeholder="Lang.get('js.choose_city')"
                       class="custom-placeholder">
              <el-option
                  v-for="(item, key) in city_list"
                  :key="key"
                  :label="item['title_' + Lang.locale]"
                  :value="key">
              </el-option>
            </el-select>
          </div>

          <div class="sort-item" v-if="city">
            <el-select v-model="office" clearable
                       @change="changeOffice"
                       :placeholder="Lang.get('js.choose_office')"
                       class="custom-placeholder">
              <el-option
                  v-for="(item, key) in city_list[city].points"
                  :key="key"
                  :label="item['name_' + Lang.locale]"
                  :value="key">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-7 col-lg-8">
<!--          <div class="map-block" v-if="city === ''">-->
<!--            <iframe src="https://www.google.com/maps/d/u/3/embed?hl=uk&mid=1nQtH3_Fgt775G4116mBXuFOrfyNI6xM&ehbc=2E312F"-->
<!--                    width="640" height="480"></iframe>-->
<!--          </div>-->
<!--          <div class="map-block" v-else v-html="office === '' ? city_list[city].map : city_list[city].points[office].map"></div>-->

          <div class="map-block">

            <div class="map-bg" v-if="activateMap" @click="activateMap = !activateMap">{{Lang.get('js.map')}}</div>

            <l-map ref="map" :zoom="mapZoom" :center="mapCenterCoords" style="height: 500px; width: 100%">
              <l-tile-layer :url="'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'"></l-tile-layer>
              <l-marker
                  v-for="(point, key) in defaultPoints"
                  :key="key"
                  :lat-lng="point.coords"
                  :icon="customIcon"
                  @click="onMarkerClick(point)"
              >
                <l-popup>{{city_list[point.city]['title_' + Lang.locale]}}, {{city_list[point.city].points[point.office]['name_' + Lang.locale]}}</l-popup>
              </l-marker>
            </l-map>
          </div>

        </div>

        <div class="col-12 col-md-5 col-lg-4">
          <div v-if="city === ''">
            <div class="filials-info">
              <div class="title">{{ Lang.get('js.main_office') }}</div>
              <div class="photo">
                <img src="/local_image/photo-main-office.jpg" :alt="Lang.get('js.main_office')">
              </div>
              <div class="mini-title">{{ Lang.get('js.odessa') }}</div>
              <div class="text">
                {{ Lang.get('js.odessa_address') }}
              </div>
              <div class="mini-title">{{ Lang.get('js.filials_map.work_hours_title') }}</div>
              <div class="text" v-html="Lang.get('js.odessa_work_hours_text')"></div>
            </div>
          </div>

          <div v-else>
            <div class="filials-info" v-if="office === ''">
              <div class="title">
                {{ Lang.get('js.filials_map.city_filial') + ' ' + city_list[city]['title_' + Lang.locale] }}
              </div>
              <div class="department-list">
                <div class="department-item"
                     @click="choosePoint(key)"
                     v-for="(department, key) in city_list[city].points">
                  {{ department['name_' + Lang.locale] }}
                </div>
              </div>
            </div>

            <div class="filials-info" v-else>
              <div class="title">{{city_list[city].points[office]['name_' + Lang.locale]}}</div>
              <div class="photo" v-if="city_list[city].points[office].preview">
                <img :src="city_list[city].points[office].preview"
                     :alt="city_list[city].points[office]['name_' + Lang.locale]">
              </div>
              <div class="mini-title">{{city_list[city]['title_' + Lang.locale]}}</div>
              <div class="text" v-html="city_list[city].points[office]['address_' + Lang.locale]"></div>
              <div class="mini-title">{{Lang.get('js.filials_map.work_hours_title')}}</div>
              <div class="text" v-html="city_list[city].points[office]['working_hours_' + Lang.locale]"></div>
              <div class="phones">
                <div class="phone" v-for="phone in city_list[city].points[office].phones">{{phone}}</div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

export default {
  name: "FilialsMap",

  components: {LMap, LTileLayer, LMarker, LPopup},

  data() {
    return {
      activateMap: true,
      customIcon: L.icon({
        iconUrl: '/local_image/location.svg',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
      }),
      mapCenterCoords: [46.48653, 30.69381],
      mapZoom: 7,
      defaultPoints: {
        0: {
          city: 'odesa',
          office: 'dobrovolskogo',
          coords: [46.57806, 30.78372],
        },
        1: {
          city: 'odesa',
          office: 'bocharova',
          coords: [46.58601, 30.80343],
        },
        2: {
          city: 'odesa',
          office: 'hmelnickogo',
          coords: [46.46648, 30.72089],
        },
        3: {
          city: 'odesa',
          office: 'novoselskogo',
          coords: [46.47939, 30.72874],
        },
        4: {
          city: 'odesa',
          office: 'koroleva',
          coords: [46.40852, 30.72013],
        },
        5: {
          city: 'odesa',
          office: 'zabolotnogo',
          coords: [46.57606, 30.80162],
        },
        6: {
          city: 'odesa',
          office: 'williams',
          coords: [46.39134, 30.72807],
        },
        7: {
          city: 'odesa',
          office: 'paliya',
          coords: [46.57077, 30.79111],
        },
        8: {
          city: 'odesa',
          office: 'arkadiya',
          coords: [46.43642, 30.75952],
        },
        9: {
          city: 'odesa',
          office: 'vorobyova',
          coords: [46.48653, 30.69381],
        },
        10: {
          city: 'arciz',
          office: 'dobrovolskogo2',
          coords: [46.00539, 29.43176],
        },
        11: {
          city: 'arciz',
          office: 'dobrovolskogo5',
          coords: [46.00724, 29.43285],
        },
        12: {
          city: 'kiliya',
          office: 'peremogy',
          coords: [45.44944, 29.27581],
        },
        13: {
          city: 'mykolaiv',
          office: 'oranta',
          coords: [46.96943, 32.01651],
        },
        14: {
          city: 'rozdilna',
          office: 'evropeyska',
          coords: [46.85865, 30.07385],
        },
        15: {
          city: 'izmail',
          office: 'suvorova',
          coords: [45.34938, 28.83526],
        },
        16: {
          city: 'izmail',
          office: 'grecka',
          coords: [45.33999, 28.82715],
        },
        17: {
          city: 'izmail',
          office: 'perekopska',
          coords: [45.353, 28.8214],
        },
        18: {
          city: 'bilgorodDnistrovskiy',
          office: 'georgievska',
          coords: [46.19035, 30.34254],
        },
        19: {
          city: 'ovidopol',
          office: 'odeska',
          coords: [46.24671, 30.44665],
        },
        20: {
          city: 'ugne',
          office: 'budivelnikiv',
          coords: [46.62548, 31.10646],
        },
        21: {
          city: 'kriveOzero',
          office: 'kobzarya',
          coords: [47.94858, 30.34565],
        },
        22: {
          city: 'odesa',
          office: 'genuezka',
          coords: [46.438252, 30.758078],
        },
        23: {
          city: 'odesa',
          office: 'arnautskaia',
          coords: [46.472219, 30.750363],
        },
        24: {
          city: 'sarata',
          office: 'soborna',
          coords: [46.023379, 29.658224],
        },
        25: {
          city: 'teplodar',
          office: 'polyova',
          coords: [46.500951, 30.324197],
        },
        26: {
          city: 'velikodolinskoe',
          office: 'svetlaia',
          coords: [46.344377, 30.574818],
        },
      },
      city: '',
      city_list: {
        odesa: {
          title_ru: 'Одесса',
          title_ua: 'Одеса',
          coords: [46.48089, 30.66591],
          points: {
            dobrovolskogo: {
              name_ru: 'пр-кт Владимира Великого, 92',
              name_ua: 'пр-кт Володимира Великого, 92',
              preview: '/local_image/department/dobrovolskogo-92.jpg',
              address_ru: 'проспект Владимира Великого, 92',
              address_ua: 'проспект Володимира Великого, 92',
              working_hours_ru: 'Пн-Пт 8:00 - 15:00,<br>Сб, Нд - вихідний',
              working_hours_ua: 'Пн-Пт 8:00 - 15:00,<br>Сб, Вс - выходной',
              phones: {
                0: '+38 (068) 147-49-52',
                1: '0 800-308-818'
              },
              coords: [46.57806, 30.78372],
            },
            bocharova: {
              name_ru: 'ул. В. Бувалкина, 60/1',
              name_ua: 'вул. В. Бувалкіна, 60/1',
              preview: '/local_image/department/bocharova.jpg',
              address_ru: 'ул. В. Бувалкина, 60/1',
              address_ua: 'вул. В. Бувалкіна, 60/1',
              working_hours_ru: 'Пн-Пт с 7:30-14:00, Сб 8:00-12:00,<br>Вс Выходной',
              working_hours_ua: 'Пн-Пт з 7:30-14:00, Сб 8:00-12:00,<br>Нд Вихідний',
              phones: {
                0: '0 800-308-818'
              },
              coords: [46.58601, 30.80343],
            },
            hmelnickogo: {
              name_ru: 'Богдана Хмельницкого, 21',
              name_ua: 'Богдана Хмельницького, 21',
              preview: '/local_image/department/bogdana-khmelnitskogo-21.jpg',
              address_ru: 'улица Богдана Хмельницкого, 21',
              address_ua: 'вулиця Богдана Хмельницького, 21',
              working_hours_ru: 'Пн-Пт 7:30-14:00, Сб 7:30-12:00,<br>Вс выходной',
              working_hours_ua: 'Пн-Пт 7:30-14:00, Сб 7:30-12:00,<br>Нд вихідний',
              phones: {
                0: '+38 (063) 121-42-33',
                1: '0 800-308-818'
              },
              coords: [46.46648, 30.72089],
            },
            novoselskogo: {
              name_ru: 'Новосельского, 94',
              name_ua: 'Новосельського, 94',
              preview: '/local_image/department/m-odesa-novosels-kogo-94.jpg',
              address_ru: 'улица Новосельского, 94',
              address_ua: 'вулиця Новосельського, 94',
              working_hours_ru: 'Пн-Пт: 8:00 - 14:00,<br>Сб-Вс Выходной',
              working_hours_ua: 'Пн-Пт: 8:00 - 14:00,<br>Сб-Нд вихідний',
              phones: {
                0: '+38 (068) 828-66-88',
                1: '+38 (063) 887-41-61',
                2: '0 800-308-818'
              },
              coords: [46.47939, 30.72874],
            },
            koroleva: {
              name_ru: 'Академика Королева, 34',
              name_ua: 'Академіка Корольова, 34',
              preview: '/local_image/department/vul-akademika-korolova-34.jpg',
              address_ru: 'улица Академика Королева, 34, угол Левитана (напротив АТБ)',
              address_ua: 'вулиця Академіка Корольова, 34, вугол Левітана (навпроти АТБ)',
              working_hours_ru: 'Пн-Пт 8:00 до 15:00, Сб 8:00 до 14:00,<br>Сб-Вс Выходной',
              working_hours_ua: 'Пн-Пт 8:00 до 15:00, Сб 8:00 до 14:00,<br>Вс Выходной',
              phones: {
                0: '+38 (095) 010-54-06',
                1: '0 800-308-818'
              },
              coords: [46.40852, 30.72013],
            },
            zabolotnogo: {
              name_ru: 'Академика Заболотного, 56/2',
              name_ua: 'Академіка Заболотного, 56/2',
              preview: '/local_image/department/akademika-zabolotnogo-56-2.jpg',
              address_ru: 'улица Академика Заболотного, 56/2',
              address_ua: 'вулиця Академика Заболотного, 56/2',
              working_hours_ru: 'Пн-Пт: 8:00 - 14:00, Сб 08:00-12:00, <br>Сб-Вс Выходной',
              working_hours_ua: 'Пн-Пт: 8:00 - 14:00, Сб 08:00-12:00, <br>Вс Выходной',
              phones: {
                0: '+38 (068) 828-86-86',
                1: '0 800-308-818'
              },
              coords: [46.57606, 30.80162],
            },
            williams: {
              name_ru: 'Академика Вильямса, 56а',
              name_ua: 'Академіка Вільямса, 56а',
              preview: '/local_image/department/odesa-vul-akademika-viliamsa.jpg',
              address_ru: 'улица Академика Вильямса, 56а, вход с торца',
              address_ua: 'вулиця Академіка Вільямса, 56а, вхід з торца',
              working_hours_ru: 'Понеділок – п\'ятниця 08.00-14.00',
              working_hours_ua: 'Понедельник - пятница 08.00-14.00',
              phones: {
                0: '+38 (063) 121-41-80',
                1: '0 800-308-818'
              },
              coords: [46.39134, 30.72807],
            },
            paliya: {
              name_ru: 'Семёна Палия, 78',
              name_ua: 'Семена Палія, 78',
              preview: '/local_image/department/semena-paliia-78.jpg',
              address_ru: 'улица Семёна Палия, 78 медицинский центр «АЛЬТ МЕД»',
              address_ua: 'вулиця Семена Палія, 78 медичний центр «АЛЬТ МЕД»',
              working_hours_ru: 'Пн-Пт: 8:15 – 13:00, Сб 8:15-11:00,<br>Вс Выходной',
              working_hours_ua: 'Пн-Пт: 8:15 – 13:00, Сб 8:15-11:00,<br>Нд Вихідний',
              phones: {
                0: '+38 (063) 121-42-41',
                1: '0 800-308-818'
              },
              coords: [46.57077, 30.79111],
            },
            arkadiya: {
              name_ru: 'Аркадия, ул. Генуэзская, 3б, 36 Жемчужина',
              name_ua: 'Аркадія, 36 Перлина, вул. Генуезька 3б',
              preview: '/local_image/department/arkadiia.jpg',
              address_ru: 'Аркадия, ул. Генуэзская, 3б, 36 Жемчужина, 2 парадная, 1 этаж, офис. 258, Домофон: 258',
              address_ua: 'Аркадія, 36 Перлина, вул. Генуезька 3б, офіс 258, Домофон: 258',
              working_hours_ru: 'Пн-Пт 8:30 до 16:00, Сб по предварительной записи,<br>Вс Выходной',
              working_hours_ua: 'Пн-Пт 8:30 до 16:00, Сб за попереднім записом,<br>Нд Вихідний',
              phones: {
                0: '+38 (096) 575-88-97',
                1: '+38 (066) 579-83-69',
                2: '0 800-308-818'
              },
              coords: [46.43642, 30.75952],
            },
            vorobyova: {
              name_ru: 'В. Нестеренко (Ак. Воробьева), 5Г',
              name_ua: 'В. Нестеренко (Ак. Воробйова) 5Г',
              preview: '/local_image/department/akademika-vorobiova-5g.jpg',
              address_ru: 'улица В. Нестеренко (Ак. Воробьева), 5Г (на пресечении улицы С. Ядова)<br>Вход со стороны Ак. Воробьева и с территории Городской клинической больницы №11, отделение травмотологии.',
              address_ua: 'вулиця В. Нестеренко (Ак. Воробйова) 5Г (на розі вулиці С. Ядова),<br>Вхід с Ак. Воробйова та з території Міської клінічної лікарні №11, відділення травмотології.',
              working_hours_ru: 'Пн-Пт: 7:30 – 14:00, Суббота: 7:30 - 12:00',
              working_hours_ua: 'Пн-ПТ: 7:30 – 14:00, Субота: з 7:30 – 12:00',
              phones: {
                0: '+38 (063) 121-42-18',
                1: '+38 (068) 147-49-52',
                2: '0 800-308-818'
              },
              coords: [46.48653, 30.69381],
            },
            genuezka: {
              name_ru: 'ул. Генуэзская 1/2',
              name_ua: 'вул. Генуезька 1/2',
              preview: '/local_image/department/odesa-vul-genuezka-1-2.jpg',
              address_ru: 'ул. Генуэзская 1/2, пл. 10 Апреля (Медицинский центр "Ликариум")',
              address_ua: 'вул. Генуезька 1/2 , пл. 10 Квітня (Медичний центр "Лікариум")',
              working_hours_ru: 'Пн-Сб: 9:00 – 17:00, Прием Пн-Пт 09:00-12:30. Суббота 9:00–12:00',
              working_hours_ua: 'Пн-Сб: 9:00 – 17:00, Прийом Пн-Пт 09:00-12:30. Субота 9:00-12:00',
              phones: {
                0: '+38 (094) 917-34-22',
                1: '0 800-308-818'
              },
              coords: [46.438252, 30.758078],
            },
            arnautskaia: {
              name_ru: 'ул. Большая Арнаутская, 2А',
              name_ua: 'вул. Велика Арнаутська, 2А',
              preview: '/local_image/department/odesa-vul-velika-arnautska-2a.jpg',
              address_ru: 'ул. Большая Арнаутская, 2А, вход с правого крыльца',
              address_ua: 'вул. Велика Арнаутська, 2А, вхід з правого крильця',
              working_hours_ru: 'Пн-Пт: 8:00 – 14:00, Сб, Вс - выходные',
              working_hours_ua: 'Пн-Пт: 8:00 – 14:00, Сб, Нд - вихідні',
              phones: {
                0: '+38 (073) 577-10-97',
                1: '+38 (068) 147-49-52',
                2: '0 800-308-818'
              },
              coords: [46.472219, 30.750363],
            },
          }
        },
        arciz: {
          title_ru: 'Арциз',
          title_ua: 'Арциз',
          coords: [45.99126, 29.43179],
          points: {
            dobrovolskogo2: {
              name_ru: 'Добровольского, 2',
              name_ua: 'Добровольського, 2',
              preview: '/local_image/department/artsiz-ul-dobrovolskogo-2.jpg',
              address_ru: 'улица Добровольского, 2',
              address_ua: 'вулиця Добровольського, 2',
              working_hours_ru: 'Пн-Пт: 8:00 – 14:00',
              working_hours_ua: 'Пн-Пт: 8:00 – 14:00',
              phones: {
                0: '+38 (063) 121-41-87',
                1: '0 800-308-818',
              },
              coords: [46.00539, 29.43176],
            },
            dobrovolskogo5: {
              name_ru: 'Добровольского, 5',
              name_ua: 'Добровольського, 5',
              preview: '/local_image/department/artsiz-vul-dobrovols-kogo-5.jpg',
              address_ru: 'улица Добровольского, 5, городская поликлиника, 2 этаж, кабинет 18',
              address_ua: 'вулиця Добровольського, 5, міська поліклініка, 2 поверх, кабінет 18',
              working_hours_ru: 'Пн-Пт: 8:00 – 14:00',
              working_hours_ua: 'Пн-Пт: 8:00 – 14:00',
              phones: {
                0: '+38 (063) 121-41-88',
                1: '0 800-308-818',
              },
              coords: [46.00724, 29.43285],
            },
          }
        },
        kiliya: {
          title_ru: 'Килия',
          title_ua: 'Кілія',
          coords: [45.44944, 29.27581],
          points: {
            peremogy: {
              name_ru: 'Победы, 67',
              name_ua: 'Перемоги, 67',
              preview: '/local_image/department/kiliia-ul-pobedy-67.jpg',
              address_ru: 'улица Победы, 67, городская поликлиника, 1 этаж, кабинет 13',
              address_ua: 'вулиця Перемоги, 67, міська пліклініка, 1 поверх, кабінет 13',
              working_hours_ru: 'Пн-Пт 7:30 - 13:00',
              working_hours_ua: 'Пн-Пт 7:30 - 13:00',
              phones: {
                0: '+38 (063) 121-41-77',
                1: '0 800-308-818',
              },
              coords: [45.44944, 29.27581],
            },
          }
        },
        mykolaiv: {
          title_ru: 'Николаев',
          title_ua: 'Миколаїв',
          coords: [46.96943, 32.01651],
          points: {
            oranta: {
              name_ru: 'Марка Кропивницкого, 202',
              name_ua: 'Марка Кропивницького, 202',
              preview: '/local_image/department/oranta-ul-potemkinskaia-202.jpg',
              address_ru: 'Клиника "Оранта", улица Марка Кропивницкого, 202',
              address_ua: 'Клініка «Оранта», вулиця Марка Кропивницького, 202',
              working_hours_ru: 'Пн-Сб 8:00 - 20:00, Прием анализов Пн-Сб 8:00 - 11:00',
              working_hours_ua: 'Пн-Сб 8:00 - 20:00, Прийом аналізів Пн-Сб 8:00 - 11:00',
              phones: {
                0: '+38 (051) 255-44-57',
                1: '0 800-308-818',
              },
              coords: [46.96943, 32.01651],
            },
          }
        },
        rozdilna: {
          title_ru: 'Раздельная',
          title_ua: 'Роздільна',
          coords: [46.85865, 30.07385],
          points: {
            evropeyska: {
              name_ru: 'Европейская 3а',
              name_ua: 'Європейська 3а',
              preview: '/local_image/department/rozdilna-vul-evropeiska-3a.jpg',
              address_ru: 'улица Европейская 3а',
              address_ua: 'вулиця Європейська 3а',
              working_hours_ru: 'Пн-Вт-Чт-Пт 8:00 - 14:00,<br>Среда-нет приема',
              working_hours_ua: 'Пн-Вт-Чт-Пт 8:00 - 14:00, <br>Середа - неприйомний день',
              phones: {
                0: '+38 (095) 01-70-783',
                1: '+38 (068) 17-90-823 Viber, Telegram',
                2: '+38 (098) 527-20-80',
              },
              coords: [46.85865, 30.07385],
            },
          }
        },
        izmail: {
          title_ru: 'Измаил',
          title_ua: 'ІзмаЇл',
          coords: [45.34938, 28.83526],
          points: {
            suvorova: {
              name_ru: 'пр-т Независимости, 67',
              name_ua: 'пр-т Незалежності, 67',
              preview: '/local_image/department/pr-t-nezalezhnosti-suvorova-67.jpg',
              address_ru: 'проспект Независимости (Суворова), 67',
              address_ua: 'проспект Незалежності (Суворова), 67',
              working_hours_ru: 'Пн-Сб 7:30 - 13:30',
              working_hours_ua: 'Пн-Сб 7:30 - 13:30',
              phones: {
                0: '+38 (096) 921-09-29',
                1: '0800 308-818',
              },
              coords: [45.34938, 28.83526],
            },
            grecka: {
              name_ru: ' Греческая, 6',
              name_ua: 'Грецька, 6',
              preview: '/local_image/department/izmail-ul-grecheskaia-6.jpg',
              address_ru: 'улица Греческая, 6',
              address_ua: 'вулиця Грецька, 6',
              working_hours_ru: 'Пн-Сб 7:30-12:30',
              working_hours_ua: 'Пн-Сб 7:30-12:30',
              phones: {
                0: '+38 (063) 121-41-50',
                1: '0800 308-818',
              },
              coords: [45.33999, 28.82715],
            },
            perekopska: {
              name_ru: 'ул. Патриотов, (Перекопской Дивизии), 1',
              name_ua: 'вул. Патриотів, (Перекопської Дивізії), 1',
              preview: '/local_image/department/izmail-ul-perekopskoi-divizii-1.jpg',
              address_ru: 'улица Патриотов, (Перекопской Дивизии), 1',
              address_ua: 'вулиця Патриотів, (Перекопської Дивізії), 1',
              working_hours_ru: 'Пн-Пт 7:30 - 12:30',
              working_hours_ua: 'Пн-Пт 7:30 - 12:30',
              phones: {
                0: '+38 (063) 121-41-52',
                1: '0800 308-818',
              },
              coords: [45.353, 28.8214],
            },
          }
        },
        bilgorodDnistrovskiy: {
          title_ru: 'Белгород-Днестровский',
          title_ua: 'Білгород-Дністровський',
          coords: [46.19035, 30.34254],
          points: {
            georgievska: {
              name_ru: 'Святогеоргиевская 12-Б',
              name_ua: 'Свято - Георгіївська 12-Б',
              preview: '/local_image/department/bilgorod-dnistrovskii-vul-sviato-georgiyivska-12-b_6.jpg',
              address_ru: 'улица Святогеоргиевская 12-Б',
              address_ua: 'вулиця Свято - Георгіївська 12-Б',
              working_hours_ru: 'Пн-Пт 7:30-15:30, Сб 8:00-13:00',
              working_hours_ua: 'Пн-Пт 7:30-15:30, Сб 8:00-13:00',
              phones: {
                0: '+38 (068) 682-27-00',
                1: '0800 308 818',
              },
              coords: [46.19035, 30.34254],
            },
          }
        },
        ovidopol: {
          title_ru: 'Овидиополь',
          title_ua: 'Овідіополь',
          coords: [46.24671, 30.44665],
          points: {
            odeska: {
              name_ru: 'Одесская, 48а',
              name_ua: 'Одеська, 48а',
              preview: '/local_image/department/ovidiopol-ul-odesskaia-48a.jpg',
              address_ru: 'улица Одесская, 48а',
              address_ua: 'вулиця Одеська, 48а',
              working_hours_ru: 'Пн-Пт 8:00 - 13:00',
              working_hours_ua: 'Пн-Пт 8:00 - 13:00',
              phones: {
                0: '+38 (063) 121-42-15',
                1: '0800 308 818',
              },
              coords: [46.24671, 30.44665],
            },
          }
        },
        ugne: {
          title_ru: 'Южный',
          title_ua: 'Южне',
          coords: [46.62548, 31.10646],
          points: {
            budivelnikiv: {
              name_ru: 'Строителей, 19',
              name_ua: 'Будівельників, 19',
              preview: '/local_image/department/stroitelei-19.jpg',
              address_ru: 'улица Строителей, 19, городская поликлиника, 1 этаж, кабинет 123',
              address_ua: 'вулиця Будівельників, 19, міська поліклініка, 1 поврех, кабінет 123',
              working_hours_ru: 'Пн-Пт 8:00 - 14:00',
              working_hours_ua: 'Пн-Пт 8:00 - 14:00',
              phones: {
                0: '+38 (063) 121-41-60',
                1: '0800 308 818',
              },
              coords: [46.62548, 31.10646],
            },
          }
        },
        kriveOzero: {
          title_ru: 'Кривое озеро',
          title_ua: 'Криве Озеро',
          coords: [47.94858, 30.34565],
          points: {
            kobzarya: {
              name_ru: 'Кобзаря, 47',
              name_ua: 'Кобзаря, 47',
              preview: '/local_image/department/krivoe-ozero-ul-kobzaria-47.jpg',
              address_ru: 'улица Кобзаря, 47',
              address_ua: 'вулиця Кобзаря, 47',
              working_hours_ru: 'Пн-Пт 7:30 - 15:00, Сб 7:30-12:00',
              working_hours_ua: 'Пн-Пт 7:30 - 15:00, Сб 7:30-12:00',
              phones: {
                0: '+38(098)-814-79-29',
                1: '0800 308 818',
              },
              coords: [47.94858, 30.34565],
            },
          }
        },
        sarata: {
          title_ru: 'Сарата',
          title_ua: 'Сарата',
          coords: [46.023379, 29.658224],
          points: {
            soborna: {
              name_ru: 'Соборна, 2',
              name_ua: 'Соборна, 2',
              address_ru: 'ул. Соборная, 2, 1 этаж поликлиники',
              address_ua: 'вул. Соборна, 2, 1 поверх полікліники',
              working_hours_ru: 'Пн-Пт 8:00 - 14:00',
              working_hours_ua: 'Пн-Пт 8:00 - 14:00',
              phones: {
                0: '+38 (063) 121-41-93',
                1: '+38 (068) 147-49-52',
                2: '0800 308 818',
              },
              coords: [46.023379, 29.658224],
            },
          }
        },
        teplodar: {
          title_ru: 'Теплодар',
          title_ua: 'Теплодар',
          coords: [46.500951, 30.324197],
          points: {
            polyova: {
              name_ru: 'ул. Польова, 2',
              name_ua: 'вул. Польова, 2',
              address_ru: 'ул. Полевая, 2, Городская больница, возле лаборатории больницы',
              address_ua: 'вул. Польова, 2, Міська лікарня, біля лабораторії лікарні',
              working_hours_ru: 'Пн-Пт 8:00 - 14:00',
              working_hours_ua: 'Пн-Пт 8:00 - 14:00',
              phones: {
                0: '+38 (063) 121-42-30',
                1: '+38 (068) 147-49-52',
                2: '0800 308 818',
              },
              coords: [46.500951, 30.324197],
            },
          }
        },
        velikodolinskoe: {
          title_ru: 'Великодолинская',
          title_ua: 'Великодолинське',
          coords: [46.344377, 30.574818],
          points: {
            svetlaia: {
              name_ru: 'ул. Светлая, 3',
              name_ua: 'вул. Світла, 3',
              address_ru: 'ул. Светлая, 3, второй этаж, Рядом с женской консультацией',
              address_ua: 'вул. Світла, 3, другий поверх, Поруч з жіночою консультацією',
              working_hours_ru: 'Пн-Пт 8:00 - 14:00',
              working_hours_ua: 'Пн-Пт 8:00 - 14:00',
              phones: {
                0: '+38 (063) 121-42-32',
                1: '+38 (068) 147-49-52',
                2: '0800 308 818',
              },
              coords: [46.344377, 30.574818],
            },
          }
        },
      },
      office: '',
      selectedCity: null,
      Lang,
    }
  },

  watch: {
    mapCenterCoords(newVal) {
      this.updateMapCenterAndZoom(newVal, this.mapZoom);
    },
    mapZoom(newVal) {
      this.updateMapCenterAndZoom(this.mapCenterCoords, newVal);
    }
  },

  methods: {
    updateMapCenterAndZoom(center, zoom) {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        map.setView(center, zoom);
      });
    },
    changeCity() {
      this.office = '';

      if(this.city !== '') {
        if(this.office === '') {
          this.mapZoom = 10;
          this.mapCenterCoords = this.city_list[this.city].coords;
        }
        else {
          this.mapZoom = 15;
          this.mapCenterCoords = this.city_list[this.city].points[this.office].coords;
        }
      }
      else {
        this.mapZoom = 8;
        this.mapCenterCoords = [46.48653, 30.69381];
      }
    },
    changeOffice() {
      if(this.city !== '') {
        if(this.office === '') {
          this.mapZoom = 10;
          this.mapCenterCoords = this.city_list[this.city].coords;
        }
        else {
          this.mapZoom = 15;
          this.mapCenterCoords = this.city_list[this.city].points[this.office].coords;
        }
      }
      else {
        this.mapZoom = 7;
        this.mapCenterCoords = [46.48653, 30.69381];
      }
    },
    choosePoint(point) {
      this.office = point;
      this.mapCenterCoords = this.city_list[this.city].points[point].coords;
      this.mapZoom = 15;
    },
    onMarkerClick(marker) {
      this.mapCenterCoords = marker.coords;
      this.mapZoom = 15;
      this.city = marker.city;
      this.office = marker.office;
    }
  },

  mounted() {
    window.addEventListener("citySelected", (event) => {
      this.city = event.detail;
      this.mapZoom = 10;
      this.mapCenterCoords = this.city_list[this.city].coords;
    });
  }

}
</script>

<style scoped>
::v-deep(.custom-placeholder .el-select__placeholder) {
  color: #000 !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/elements/FilialsMap.vue